import React from 'react';
import PropTypes from 'prop-types';
import css from './PreviewUrl.css';

const PREVIEW_BASE = 'https://sng.link/A1b2c/example';

const PreviewUrl = ({ parameters }) => {
    const filled = parameters.filter(p => p.partner_macro && p.singular_key);
    if (!filled.length) return null;
    return (
        <span>
            {PREVIEW_BASE}?
            {filled.map((p, i) => (
                <span key={p.singular_key || i}>
                    {i > 0 && '&'}
                    {p.singular_key}=<span className={css.previewValue}>{p.partner_macro}</span>
                </span>
            ))}
        </span>
    );
};

PreviewUrl.propTypes = {
    parameters: PropTypes.arrayOf(
        PropTypes.shape({
            singular_key: PropTypes.string,
            partner_macro: PropTypes.string,
        })
    ).isRequired,
};

export default PreviewUrl;
